import { MouseEventHandler, PropsWithChildren } from 'react';
import * as RadioGroup from '@givebutter/primitives/radio-group';
import { BranchConditionOptionLabel } from 'assets/js/pages/engage/workflows/components/BranchConditionOptionLabel';
import * as Tooltip from 'components/tooltip';
import { BranchConditionEnum } from 'constants/workflows';
import { twMerge } from 'tailwind-merge';

interface BranchConditionItemProps extends PropsWithChildren {
    condition: BranchConditionEnum;
    isDisabled?: boolean;
    onClick?: MouseEventHandler<HTMLButtonElement>;
}
const BranchConditionItem = ({
    children,
    condition,
    isDisabled,
    onClick,
}: BranchConditionItemProps) => {
    return (
        <Tooltip.Root key={condition} open={isDisabled ? undefined : false}>
            <Tooltip.Trigger asChild>
                <RadioGroup.Item
                    value={condition}
                    className={twMerge(
                        'flex items-center gap-2.5 rounded-lg p-3 px-4 font-medium text-gray-800',
                        !isDisabled && 'hover:shadow-sm',
                    )}
                    disabled={isDisabled}
                    onClick={e => {
                        onClick?.(e);
                    }}
                >
                    <BranchConditionOptionLabel condition={condition} />
                    {children}
                </RadioGroup.Item>
            </Tooltip.Trigger>
        </Tooltip.Root>
    );
};

const BranchConditionItemMessageTooltipContent = () => {
    return (
        <Tooltip.Portal>
            <Tooltip.Content inverse side="right">
                <Tooltip.Arrow inverse />
                <div className="flex min-w-72 flex-col gap-1">
                    <p className="font-medium">No existing messages</p>
                    <p className="text-xs">
                        Your workflow has no message available to set as a condition.
                    </p>
                </div>
            </Tooltip.Content>
        </Tooltip.Portal>
    );
};

const Root = BranchConditionItem;
const MessageTooltipContent = BranchConditionItemMessageTooltipContent;

export {
    Root,
    MessageTooltipContent,
    //
    BranchConditionItem,
    BranchConditionItemMessageTooltipContent,
};
